import moment from 'moment';
import { useEffect, useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import barcode_image from '../../../../assets/media/barcode-scan.png';
import { Button } from '../../../../components/Basic/Buttons';
import { Icon } from '../../../../components/Basic/Elements';
import { Input } from "../../../../components/Basic/Inputs";
import { TableCell, TableLine } from "../../../../components/Basic/Table";
import { TYPE_BUTTONS } from "../../../../constans";
import styles from './styles.module.scss';


function CardLine({ card, onPrint }) {

    const [barcodeQuantity, setBarcodeQuantity] = useState(Math.floor(card.warehouse_stock / card.quantity) || 1);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [images, setImages] = useState([]);

    useEffect(() => {
        setBarcodeQuantity(Math.floor(card.warehouse_stock / card.quantity) || 1)
    }, [card]);

    const openImageViewer = (imgs) => {
        setImages(imgs);
        setIsViewerOpen(true);
    };

    const closeImageViewer = () => {
        setIsViewerOpen(false);
        setImages([]);
    };

    return (
        <>
            <TableLine >
                <TableCell width={'60px'} center={true}>
                    <div style={{ fontSize: '15px', color: '#6c107cff' }}> {card.shop}</div>
                </TableCell>
                <TableCell width={'70px'} center={true}>
                    <div>
                        <Button
                            style={{ padding: '2px' }}
                            disabled={!Number.isInteger(+barcodeQuantity) || +barcodeQuantity <= 0 || +barcodeQuantity > Math.floor(card.warehouse_stock / card.quantity) || !card.is_same_shop}
                            type={TYPE_BUTTONS.WHITE}
                            className={styles.white_button}
                            onClick={() =>
                                onPrint({ shop: card.shop, offerId: card.offer_id, barcodeQuantity: +barcodeQuantity, productQuantity: +barcodeQuantity, action: 'add_new_item' })
                            }>
                            <Icon src={barcode_image} width="35px" />
                        </Button>
                    </div>
                </TableCell>
                <TableCell width={'50px'} center={true}>
                    <Input
                        center={true}
                        value={barcodeQuantity}
                        onClickEnter={(v) => setBarcodeQuantity(v)}
                        onBlur={(v) => setBarcodeQuantity(v)}
                    />
                </TableCell>
                <TableCell width={'280px'} >
                    <div className={styles.div_line_images}>
                        <div className={styles.wrapper}>
                            <img
                                onClick={() => openImageViewer(card.images)}
                                className={styles.preview}
                                src={(card.images || []).length > 0 ? card.images[0] : undefined}
                            />
                            {
                                moment(card.created_at).diff('2025-11-27') > 0 &&
                                < div style={{ position: 'absolute', backgroundColor: '#4ad84cd5', padding: '0 5px', top: '39px', borderRadius: '6px', color: '#1f1d1de9' }}>
                                    Новая
                                </div>
                            }
                        </div>
                        <div className={styles.name}>
                            {card.name}
                        </div>

                        <div className={styles.name}>

                        </div>
                    </div>
                </TableCell>
                {/* <TableCell width={'100px'} center={true}>
                    <Row>
                        <div style={{ fontWeight: '600', fontSize: '24px', }}>
                            {card.warehouse_stock }
                        </div>
                        <div>{card.warehouse_address && `  (${card.warehouse_address})`}</div>
                    </Row>

                </TableCell> */}
                <TableCell width={'100px'} center={true}>
                    <div style={{ fontWeight: '600', fontSize: '24px', }}>
                        {card.quantity}
                    </div>
                </TableCell>
                {/* <TableCell width={'190px'} center={true}>
                    {card.offer_id}
                </TableCell> */}
                {/* <TableCell width={'100px'} center={true}>
                    {card.sale_statistic.num_sales || '-'}
                </TableCell>
                <TableCell width={'100px'} center={true}>
                    {card.prices.price}
                </TableCell> */}
                <TableCell width={'130px'} center={true}>
                    {card.provider_sku}
                </TableCell>

            </TableLine >
            {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />
            }
        </>
    );
}

export default CardLine
